import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'ag-village-page',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './village-page.component.html',
  styleUrl: './village-page.component.css'
})
export class VillagePageComponent {
  private readonly route = inject(ActivatedRoute);

  readonly title = this.route.snapshot.data['title'] as string;
  readonly location = this.route.snapshot.data['location'] as string;
  readonly description = this.route.snapshot.data['description'] as string;
}
